module.exports = __webpack_public_path__ + "static/img/login.71d80f57.svg";